import type { GetServerSidePropsContext } from "next/types";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import { faChartArea } from "@fortawesome/free-solid-svg-icons/faChartArea";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import ToolPageLayout from "components/ToolPageLayout";
import ToolRelativeValue from "components/ToolRelativeValue";
import type { NextPageWithLayout } from "pages/_app";
import Error from "pages/_error";
import {
  authenticatedAccountUrl,
  sessionFromContextCookie,
} from "hooks/useAuthentication";
import { baseFetcher } from "utils/baseFetcher";

const ToolRelativeValuePage: NextPageWithLayout = ({}: any) => {
  return <ToolRelativeValue />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const session = sessionFromContextCookie(context);
    const accountId = session?.authenticated?.account_id;

    const accountUrl = authenticatedAccountUrl(accountId);
    const account = await baseFetcher(accountUrl, context);

    try {
      await baseFetcher(
        `/api/v2/tools/relative-value?public_allowed=true`,
        context
      );
    } catch {}

    return {
      props: {
        fallback: {
          [accountUrl]: account,
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps Executives Analytics Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return {
      props: {
        fallback: {},
      },
    };
  }
}

ToolRelativeValuePage.getLayout = (page, { pageProps }) => {
  const { fallback, errorCode } = pageProps;

  if (errorCode) return <Error statusCode={errorCode} />;

  return (
    <SWRConfig value={{ fallback }}>
      <ToolPageLayout
        breadcrumb={[
          {
            title: "Smartkarma Relative Value",
            href: `/tools/smart-score-screener`,
            icon: <FontAwesomeIcon icon={faChartArea} />,
          },
        ]}
        title="Smartkarma Relative Value"
        description="Monitor price ratios of closely correlated pairs such as HoldCos, and Share classes"
      >
        {page}
      </ToolPageLayout>
    </SWRConfig>
  );
};

export default ToolRelativeValuePage;
